// @ts-check

import React, { useMemo } from "react";

import { BlockStack, Card, InlineStack, Text } from "@shopify/polaris";
import { LineChart } from "@shopify/polaris-viz";

import { dateRangeTypeToWords } from "components/DateRangePicker/util";
import { SyncingPlaceholder } from "components/SyncingPlaceholder/SyncingPlaceholder";

import { useGlobalContext } from "context/GlobalContext";

export const OrdersLineChartCard = ({
  title,
  dataTitle,
  loading,
  data: _data,
  totalOrders,
}) => {
  const { syncing, datePeriodType } = useGlobalContext();

  const data = useMemo(() => {
    return [
      {
        name: dataTitle,
        data: _data || [],
      },
    ];
  }, [_data, dataTitle]);

  const loadingStats = loading || syncing;

  return (
    <Card>
      <BlockStack gap="800">
        <InlineStack align="space-between">
          <BlockStack>
            <Text as="h2" variant="headingSm" tone="subdued" fontWeight="regular">
              {title}
            </Text>

            <Text variant="headingLg" as="p" fontWeight="regular" tone={loadingStats ? "subdued" : undefined}>
              {loadingStats ? "..." : totalOrders}
            </Text>
          </BlockStack>

          <BlockStack>
            <Text variant="bodyMd" as="p" tone="subdued">
              {dateRangeTypeToWords(datePeriodType)}
            </Text>
          </BlockStack>
        </InlineStack>

        <SyncingPlaceholder variant="line-chart">
          <LineChart
            theme="Light"
            data={data}
            xAxisOptions={{ hide: true }}
            showLegend={false}
          />
        </SyncingPlaceholder>
      </BlockStack>
    </Card>
  );
};
